<template>
    <v-dialog v-model="dialog" max-width="500" persistent>
        <v-card>
            <v-card-title class="primary white--text title">
                {{ 'Report'|translate }}
            </v-card-title>
            <v-card-text>
                <v-text-field
                    :label="'Title'|translate"
                    v-model="activeItem.title"
                >
                </v-text-field>
                <v-text-field
                    :label="'Description'|translate"
                    v-model="activeItem.description"
                >
                </v-text-field>
                <v-combobox
                    :items="topicSuggestions"
                    :label="'Topic'|translate"
                    v-model="activeItem.topic"
                ></v-combobox>
                <severity-selector v-model="activeItem.severity_levels"
                                   attach
                                   chips
                                   multiple
                                   :label="'Severity Levels'|translate"></severity-selector>
                <v-select
                    :items="items"
                    :label="'Frequency'|translate"
                    v-model="activeItem.email_frequency"
                ></v-select>
                <v-switch color="success"
                          v-model="activeItem.report_active"
                          :label="'Active'|translate"
                ></v-switch>

                <v-textarea
                    :label="'Distribution List'|translate"
                    v-model="activeItem.emails"
                    hint="One contact per line"
                    auto-grow
                ></v-textarea>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outline class="mr-2" @click="dialog=false">{{ 'Cancel'|translate }}</v-btn>
                <v-btn class="primary mr-2 elevation-4" @click="addRecord(true)" :disabled="!$can('update', 'Report')">
                    {{ 'Save'|translate }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {putReportConfig} from '../../helper'
import SeveritySelector from "../SeveritySelector";

export default {
    props: {
        value: {type: Boolean, default: true},
        item: {type: Object, default: null}
    },
    components: {SeveritySelector},
    watch: {
        item(item) {
            this.initializeVar()
            if (item) {
                if (!item.severity_levels) {
                    item.severity_levels = [];
                } else if ((typeof item.severity_levels === 'string' || item.severity_levels instanceof String)) {
                    item.severity_levels = item.severity_levels.split(',')
                }
                this.activeItem = this.item
            }
        },
        value() {
            if (this.dialog != this.value) {
                this.dialog = this.value
            }
        },
        dialog() {
            this.$emit('input', this.dialog)
        }
    },
    data() {
        return {
            items: ['daily summary', 'weekly summary', 'after 5 occurrences', 'immediate','always'],
            topicSuggestions:['all','sensor', 'maintenance', 'control logic', 'energy', 'operation','equipment health'],
            dialog: false,
            activeItem: {
                emails: '',
                topic: 'all',
                email_frequency: '',
                report_active: false,
                severity_levels: [],
                reportconfig_id: null
            },

        }
    },
    methods: {
        initializeVar(close) {
            this.activeItem = {
                emails: '',
                topic: 'all',
                email_frequency: '',
                report_active: false,
                severity_levels: [],
                reportconfig_id: null
            }
            if (close) {
                this.dialog = false;
            }
        },
        async addRecord(close) {
            let param = Object.assign({}, this.activeItem)
            if (Array.isArray(param.severity_levels)) {
                param.severity_levels = param.severity_levels.join(',')
            }
            param['facility_name'] = this.$store.state.pointsListStore.pointsList.facility_name
            await putReportConfig(
                param
            )
            if (close) {
                this.dialog = false;
            }
            this.$emit('doreload')
        }
    },
    name: 'ReportConfigDialog'
}
</script>

<style scoped>

</style>
